/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ParcelaPaginado } from '../models/parcela-paginado';
import { Parcela } from '../models/parcela';
import { ParcelaLista } from '../models/parcela-lista';
import { Message } from '../models/message';

/**
 * As parcelas sao criadas somente apos a finalizacao do processo de aprovacao de geracao do acordo, conforme os parametros informados no acordo.
 */
@Injectable({
  providedIn: 'root',
})
class ParcelaService extends __BaseService {
  static readonly obterParcelasPath = '/parcelas/{codigoAcordo}';
  static readonly obterRelatorioParcelaPath = '/parcelas/relatorio';
  static readonly obterParcelasPorNumeroSinistroPath = '/parcelas/sinistro/{numeroSinistro}';
  static readonly obterParcelasLoteFaturaPath = '/parcelas/lote-fatura';
  static readonly obterParcelasLoteHonorarioPath = '/parcelas/lote-honorario';
  static readonly obterParcelasReceberLoteHonorarioPath = '/parcelas/receber-lote-honorario';
  static readonly obterParcelasParaConciliacaoPath = '/parcelas/conciliacao';
  static readonly atualizarStatusSAPParcelaPath = '/parcelas/atualizarStatusSAPParcela';
  static readonly realizarEstornoSAPParcelaPath = '/parcelas/realizarEstornoSAPParcela';
  static readonly atualizarLoteParcelaPath = '/parcelas/atualizarLoteParcela';
  static readonly salvarParcelaPath = '/parcelas';
  static readonly alterarParcelaPath = '/parcelas';
  static readonly gravarParcelasAcordoDSPath = '/service/parcelas/gravarParcelasAcordoDS';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Recupera uma listagem dos acordos com base nos parametros informados
   * @param params The `ParcelaService.ObterParcelasParams` containing the following parameters:
   *
   * - `codigoAcordo`: Codigo do acordo
   *
   * - `codigoParcela`: Codigo do parcela
   *
   * @return Operacao realizada com sucesso
   */
  obterParcelasResponse(params: ParcelaService.ObterParcelasParams): __Observable<__StrictHttpResponse<ParcelaPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.codigoParcela != null) __params = __params.set('codigoParcela', params.codigoParcela.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/parcelas/${encodeURIComponent(String(params.codigoAcordo))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ParcelaPaginado>;
      })
    );
  }
  /**
   * Recupera uma listagem dos acordos com base nos parametros informados
   * @param params The `ParcelaService.ObterParcelasParams` containing the following parameters:
   *
   * - `codigoAcordo`: Codigo do acordo
   *
   * - `codigoParcela`: Codigo do parcela
   *
   * @return Operacao realizada com sucesso
   */
  obterParcelas(params: ParcelaService.ObterParcelasParams): __Observable<ParcelaPaginado> {
    return this.obterParcelasResponse(params).pipe(
      __map(_r => _r.body as ParcelaPaginado)
    );
  }

  /**
   * Retorna relatorio de parcelas com base na lista de parcela passada
   * @param relatorioRequest Objeto relatorio request
   * @return Relatório gerado com sucesso
   */
  obterRelatorioParcelaResponse(relatorioRequest?: Array<Parcela>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = relatorioRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/parcelas/relatorio`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * Retorna relatorio de parcelas com base na lista de parcela passada
   * @param relatorioRequest Objeto relatorio request
   * @return Relatório gerado com sucesso
   */
  obterRelatorioParcela(relatorioRequest?: Array<Parcela>): __Observable<Blob> {
    return this.obterRelatorioParcelaResponse(relatorioRequest).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * Recupera uma listagem dos acordos com base nos parametros informados
   * @param numeroSinistro Numero do sinistro
   * @return Operacao realizada com sucesso
   */
  obterParcelasPorNumeroSinistroResponse(numeroSinistro: number): __Observable<__StrictHttpResponse<ParcelaLista>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/parcelas/sinistro/${encodeURIComponent(String(numeroSinistro))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ParcelaLista>;
      })
    );
  }
  /**
   * Recupera uma listagem dos acordos com base nos parametros informados
   * @param numeroSinistro Numero do sinistro
   * @return Operacao realizada com sucesso
   */
  obterParcelasPorNumeroSinistro(numeroSinistro: number): __Observable<ParcelaLista> {
    return this.obterParcelasPorNumeroSinistroResponse(numeroSinistro).pipe(
      __map(_r => _r.body as ParcelaLista)
    );
  }

  /**
   * Recupera uma listagem dos parcelas com base nos parametros informados
   * @param params The `ParcelaService.ObterParcelasLoteFaturaParams` containing the following parameters:
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `numeroSinistro`: Numero do sinistro
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `anoSinistro`: Ano do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterParcelasLoteFaturaResponse(params: ParcelaService.ObterParcelasLoteFaturaParams): __Observable<__StrictHttpResponse<ParcelaPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.ramoSinistro != null) __params = __params.set('ramoSinistro', params.ramoSinistro.toString());
    if (params.periodoInicial != null) __params = __params.set('periodoInicial', params.periodoInicial.toString());
    if (params.periodoFinal != null) __params = __params.set('periodoFinal', params.periodoFinal.toString());
    if (params.perPage != null) __params = __params.set('perPage', params.perPage.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.numeroSinistro != null) __params = __params.set('numeroSinistro', params.numeroSinistro.toString());
    if (params.codigoEscritorio != null) __params = __params.set('codigoEscritorio', params.codigoEscritorio.toString());
    if (params.anoSinistro != null) __params = __params.set('anoSinistro', params.anoSinistro.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/parcelas/lote-fatura`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ParcelaPaginado>;
      })
    );
  }
  /**
   * Recupera uma listagem dos parcelas com base nos parametros informados
   * @param params The `ParcelaService.ObterParcelasLoteFaturaParams` containing the following parameters:
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `numeroSinistro`: Numero do sinistro
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `anoSinistro`: Ano do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterParcelasLoteFatura(params: ParcelaService.ObterParcelasLoteFaturaParams): __Observable<ParcelaPaginado> {
    return this.obterParcelasLoteFaturaResponse(params).pipe(
      __map(_r => _r.body as ParcelaPaginado)
    );
  }

  /**
   * Recupera uma listagem dos parcelas com base nos parametros informados
   * @param params The `ParcelaService.ObterParcelasLoteHonorarioParams` containing the following parameters:
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `codigoTipoProcedencia`: Codigo identificador do tipo de procedencia
   *
   * - `codigoModalidade`: Codigo da Modalidade (Marca)
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `anoSinistro`: Ano do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterParcelasLoteHonorarioResponse(params: ParcelaService.ObterParcelasLoteHonorarioParams): __Observable<__StrictHttpResponse<ParcelaPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.ramoSinistro != null) __params = __params.set('ramoSinistro', params.ramoSinistro.toString());
    if (params.periodoInicial != null) __params = __params.set('periodoInicial', params.periodoInicial.toString());
    if (params.periodoFinal != null) __params = __params.set('periodoFinal', params.periodoFinal.toString());
    if (params.perPage != null) __params = __params.set('perPage', params.perPage.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.codigoTipoProcedencia != null) __params = __params.set('codigoTipoProcedencia', params.codigoTipoProcedencia.toString());
    if (params.codigoModalidade != null) __params = __params.set('codigoModalidade', params.codigoModalidade.toString());
    if (params.codigoEscritorio != null) __params = __params.set('codigoEscritorio', params.codigoEscritorio.toString());
    if (params.anoSinistro != null) __params = __params.set('anoSinistro', params.anoSinistro.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/parcelas/lote-honorario`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ParcelaPaginado>;
      })
    );
  }
  /**
   * Recupera uma listagem dos parcelas com base nos parametros informados
   * @param params The `ParcelaService.ObterParcelasLoteHonorarioParams` containing the following parameters:
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `codigoTipoProcedencia`: Codigo identificador do tipo de procedencia
   *
   * - `codigoModalidade`: Codigo da Modalidade (Marca)
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `anoSinistro`: Ano do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterParcelasLoteHonorario(params: ParcelaService.ObterParcelasLoteHonorarioParams): __Observable<ParcelaPaginado> {
    return this.obterParcelasLoteHonorarioResponse(params).pipe(
      __map(_r => _r.body as ParcelaPaginado)
    );
  }

  /**
   * Recupera uma listagem dos parcelas com base nos parametros informados
   * @param params The `ParcelaService.ObterParcelasReceberLoteHonorarioParams` containing the following parameters:
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `codigoTipoProcedencia`: Codigo identificador do tipo de procedencia
   *
   * - `codigoModalidade`: Codigo da Modalidade (Marca)
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `anoSinistro`: Ano do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterParcelasReceberLoteHonorarioResponse(params: ParcelaService.ObterParcelasReceberLoteHonorarioParams): __Observable<__StrictHttpResponse<ParcelaPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.ramoSinistro != null) __params = __params.set('ramoSinistro', params.ramoSinistro.toString());
    if (params.periodoInicial != null) __params = __params.set('periodoInicial', params.periodoInicial.toString());
    if (params.periodoFinal != null) __params = __params.set('periodoFinal', params.periodoFinal.toString());
    if (params.perPage != null) __params = __params.set('perPage', params.perPage.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.codigoTipoProcedencia != null) __params = __params.set('codigoTipoProcedencia', params.codigoTipoProcedencia.toString());
    if (params.codigoModalidade != null) __params = __params.set('codigoModalidade', params.codigoModalidade.toString());
    if (params.codigoEscritorio != null) __params = __params.set('codigoEscritorio', params.codigoEscritorio.toString());
    if (params.anoSinistro != null) __params = __params.set('anoSinistro', params.anoSinistro.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/parcelas/receber-lote-honorario`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ParcelaPaginado>;
      })
    );
  }
  /**
   * Recupera uma listagem dos parcelas com base nos parametros informados
   * @param params The `ParcelaService.ObterParcelasReceberLoteHonorarioParams` containing the following parameters:
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `codigoTipoProcedencia`: Codigo identificador do tipo de procedencia
   *
   * - `codigoModalidade`: Codigo da Modalidade (Marca)
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `anoSinistro`: Ano do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterParcelasReceberLoteHonorario(params: ParcelaService.ObterParcelasReceberLoteHonorarioParams): __Observable<ParcelaPaginado> {
    return this.obterParcelasReceberLoteHonorarioResponse(params).pipe(
      __map(_r => _r.body as ParcelaPaginado)
    );
  }

  /**
   * Recupera uma listagem dos parcelas com base nos parametros informados
   * @param params The `ParcelaService.ObterParcelasParaConciliacaoParams` containing the following parameters:
   *
   * - `sequenciaItemSinistro`: Item do sinistro
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `numeroSinistro`: Numero do sinistro
   *
   * - `cpfCnpj`: Cpf/Cnpj
   *
   * - `codigoTipoProcedencia`: Codigo identificador do tipo de procedencia
   *
   * - `codigoStatus`: Codigo status da parcela
   *
   * - `codigoModalidade`: Codigo da Modalidade (Marca)
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `codigoAcordo`: Codigo do acordo
   *
   * - `anoSinistro`: Ano do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterParcelasParaConciliacaoResponse(params: ParcelaService.ObterParcelasParaConciliacaoParams): __Observable<__StrictHttpResponse<ParcelaPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.sequenciaItemSinistro != null) __params = __params.set('sequenciaItemSinistro', params.sequenciaItemSinistro.toString());
    if (params.sequenciaItemSinistro1 != null) __params = __params.set('sequenciaItemSinistro1', params.sequenciaItemSinistro1.toString());
    if (params.sequenciaItemSinistro2 != null) __params = __params.set('sequenciaItemSinistro2', params.sequenciaItemSinistro2.toString());
    if (params.sequenciaItemSinistro3 != null) __params = __params.set('sequenciaItemSinistro3', params.sequenciaItemSinistro3.toString());
    if (params.sequenciaItemSinistro4 != null) __params = __params.set('sequenciaItemSinistro4', params.sequenciaItemSinistro4.toString());
    if (params.sequenciaItemSinistro5 != null) __params = __params.set('sequenciaItemSinistro5', params.sequenciaItemSinistro5.toString());
    if (params.sequenciaItemSinistro6 != null) __params = __params.set('sequenciaItemSinistro6', params.sequenciaItemSinistro6.toString());
    if (params.sequenciaItemSinistro7 != null) __params = __params.set('sequenciaItemSinistro7', params.sequenciaItemSinistro7.toString());
    if (params.sequenciaItemSinistro8 != null) __params = __params.set('sequenciaItemSinistro8', params.sequenciaItemSinistro8.toString());
    if (params.sequenciaItemSinistro9 != null) __params = __params.set('sequenciaItemSinistro9', params.sequenciaItemSinistro9.toString());
    if (params.ramoSinistro != null) __params = __params.set('ramoSinistro', params.ramoSinistro.toString());
    if (params.ramoSinistro1 != null) __params = __params.set('ramoSinistro1', params.ramoSinistro1.toString());
    if (params.ramoSinistro2 != null) __params = __params.set('ramoSinistro2', params.ramoSinistro2.toString());
    if (params.ramoSinistro3 != null) __params = __params.set('ramoSinistro3', params.ramoSinistro3.toString());
    if (params.ramoSinistro4 != null) __params = __params.set('ramoSinistro4', params.ramoSinistro4.toString());
    if (params.ramoSinistro5 != null) __params = __params.set('ramoSinistro5', params.ramoSinistro5.toString());
    if (params.ramoSinistro6 != null) __params = __params.set('ramoSinistro6', params.ramoSinistro6.toString());
    if (params.ramoSinistro7 != null) __params = __params.set('ramoSinistro7', params.ramoSinistro7.toString());
    if (params.ramoSinistro8 != null) __params = __params.set('ramoSinistro8', params.ramoSinistro8.toString());
    if (params.ramoSinistro9 != null) __params = __params.set('ramoSinistro9', params.ramoSinistro9.toString());
    if (params.perPage != null) __params = __params.set('perPage', params.perPage.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.numeroSinistro != null) __params = __params.set('numeroSinistro', params.numeroSinistro.toString());
    if (params.numeroSinistro1 != null) __params = __params.set('numeroSinistro1', params.numeroSinistro1.toString());
    if (params.numeroSinistro2 != null) __params = __params.set('numeroSinistro2', params.numeroSinistro2.toString());
    if (params.numeroSinistro3 != null) __params = __params.set('numeroSinistro3', params.numeroSinistro3.toString());
    if (params.numeroSinistro4 != null) __params = __params.set('numeroSinistro4', params.numeroSinistro4.toString());
    if (params.numeroSinistro5 != null) __params = __params.set('numeroSinistro5', params.numeroSinistro5.toString());
    if (params.numeroSinistro6 != null) __params = __params.set('numeroSinistro6', params.numeroSinistro6.toString());
    if (params.numeroSinistro7 != null) __params = __params.set('numeroSinistro7', params.numeroSinistro7.toString());
    if (params.numeroSinistro8 != null) __params = __params.set('numeroSinistro8', params.numeroSinistro8.toString());
    if (params.numeroSinistro9 != null) __params = __params.set('numeroSinistro9', params.numeroSinistro9.toString());
    if (params.cpfCnpj != null) __params = __params.set('cpfCnpj', params.cpfCnpj.toString());
    if (params.codigoTipoProcedencia != null) __params = __params.set('codigoTipoProcedencia', params.codigoTipoProcedencia.toString());
    if (params.codigoStatus != null) __params = __params.set('codigoStatus', params.codigoStatus.toString());
    if (params.codigoModalidade != null) __params = __params.set('codigoModalidade', params.codigoModalidade.toString());
    if (params.codigoEscritorio != null) __params = __params.set('codigoEscritorio', params.codigoEscritorio.toString());
    if (params.codigoAcordo != null) __params = __params.set('codigoAcordo', params.codigoAcordo.toString());
    if (params.codigoAcordo1 != null) __params = __params.set('codigoAcordo1', params.codigoAcordo1.toString());
    if (params.codigoAcordo2 != null) __params = __params.set('codigoAcordo2', params.codigoAcordo2.toString());
    if (params.codigoAcordo3 != null) __params = __params.set('codigoAcordo3', params.codigoAcordo3.toString());
    if (params.codigoAcordo4 != null) __params = __params.set('codigoAcordo4', params.codigoAcordo4.toString());
    if (params.codigoAcordo5 != null) __params = __params.set('codigoAcordo5', params.codigoAcordo5.toString());
    if (params.codigoAcordo6 != null) __params = __params.set('codigoAcordo6', params.codigoAcordo6.toString());
    if (params.codigoAcordo7 != null) __params = __params.set('codigoAcordo7', params.codigoAcordo7.toString());
    if (params.codigoAcordo8 != null) __params = __params.set('codigoAcordo8', params.codigoAcordo8.toString());
    if (params.codigoAcordo9 != null) __params = __params.set('codigoAcordo9', params.codigoAcordo9.toString());
    if (params.anoSinistro != null) __params = __params.set('anoSinistro', params.anoSinistro.toString());
    if (params.anoSinistro1 != null) __params = __params.set('anoSinistro1', params.anoSinistro1.toString());
    if (params.anoSinistro2 != null) __params = __params.set('anoSinistro2', params.anoSinistro2.toString());
    if (params.anoSinistro3 != null) __params = __params.set('anoSinistro3', params.anoSinistro3.toString());
    if (params.anoSinistro4 != null) __params = __params.set('anoSinistro4', params.anoSinistro4.toString());
    if (params.anoSinistro5 != null) __params = __params.set('anoSinistro5', params.anoSinistro5.toString());
    if (params.anoSinistro6 != null) __params = __params.set('anoSinistro6', params.anoSinistro6.toString());
    if (params.anoSinistro7 != null) __params = __params.set('anoSinistro7', params.anoSinistro7.toString());
    if (params.anoSinistro8 != null) __params = __params.set('anoSinistro8', params.anoSinistro8.toString());
    if (params.anoSinistro9 != null) __params = __params.set('anoSinistro9', params.anoSinistro9.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/parcelas/conciliacao`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ParcelaPaginado>;
      })
    );
  }
  /**
   * Recupera uma listagem dos parcelas com base nos parametros informados
   * @param params The `ParcelaService.ObterParcelasParaConciliacaoParams` containing the following parameters:
   *
   * - `sequenciaItemSinistro`: Item do sinistro
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `numeroSinistro`: Numero do sinistro
   *
   * - `cpfCnpj`: Cpf/Cnpj
   *
   * - `codigoTipoProcedencia`: Codigo identificador do tipo de procedencia
   *
   * - `codigoStatus`: Codigo status da parcela
   *
   * - `codigoModalidade`: Codigo da Modalidade (Marca)
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `codigoAcordo`: Codigo do acordo
   *
   * - `anoSinistro`: Ano do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterParcelasParaConciliacao(params: ParcelaService.ObterParcelasParaConciliacaoParams): __Observable<ParcelaPaginado> {
    return this.obterParcelasParaConciliacaoResponse(params).pipe(
      __map(_r => _r.body as ParcelaPaginado)
    );
  }

  /**
   * Altera os dados de uma parcela
   * @param acordo Objeto da parcela
   */
  atualizarStatusSAPParcelaResponse(acordo: Parcela): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = acordo;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/parcelas/atualizarStatusSAPParcela`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Altera os dados de uma parcela
   * @param acordo Objeto da parcela
   */
  atualizarStatusSAPParcela(acordo: Parcela): __Observable<null> {
    return this.atualizarStatusSAPParcelaResponse(acordo).pipe(
      __map(_r => _r.body as null)
    );
  }

/**
   * Altera os dados de uma parcela
   * @param acordo Objeto da parcela
   */
realizarEstornoSAPParcelaResponse(acordo: Parcela): __Observable<__StrictHttpResponse<null>> {
  let __params = this.newParams();
  let __headers = new HttpHeaders();
  let __body: any = null;
  __body = acordo;
  let req = new HttpRequest<any>(
    'POST',
    this.rootUrl + `/parcelas/realizarEstornoSAPParcela`,
    __body,
    {
      headers: __headers,
      params: __params,
      responseType: 'json'
    });

  return this.http.request<any>(req).pipe(
    __filter(_r => _r instanceof HttpResponse),
    __map((_r) => {
      return _r as __StrictHttpResponse<null>;
    })
  );
}
 /**
   * Altera os dados de uma parcela
   * @param acordo Objeto da parcela
   */
 realizarEstornoSAPParcela(acordo: Parcela): __Observable<null> {
  return this.realizarEstornoSAPParcelaResponse(acordo).pipe(
    __map(_r => _r.body as null)
  );
}
  /**
   * Altera os dados de uma parcela
   * @param acordo Objeto da parcela
   */
  atualizarLoteParcelaResponse(acordo: Parcela): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = acordo;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/parcelas/atualizarLoteParcela`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Altera os dados de uma parcela
   * @param acordo Objeto da parcela
   */
  atualizarLoteParcela(acordo: Parcela): __Observable<null> {
    return this.atualizarLoteParcelaResponse(acordo).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Cadastro de parcela(s) de um determinado acordo
   * @param parcela Objeto da parcela
   */
  salvarParcelaResponse(parcela: Parcela): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = parcela;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/parcelas`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Cadastro de parcela(s) de um determinado acordo
   * @param parcela Objeto da parcela
   */
  salvarParcela(parcela: Parcela): __Observable<null> {
    return this.salvarParcelaResponse(parcela).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Altera os dados de uma parcela
   * @param acordo Objeto da parcela
   */
  alterarParcelaResponse(acordo: Parcela): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = acordo;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/parcelas`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Altera os dados de uma parcela
   * @param acordo Objeto da parcela
   */
  alterarParcela(acordo: Parcela): __Observable<null> {
    return this.alterarParcelaResponse(acordo).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Recupera as parcelas pendentes de envio ao DS e grava na base do DS
   * @return Operacao realizada com sucesso
   */
  gravarParcelasAcordoDSResponse(): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/service/parcelas/gravarParcelasAcordoDS`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Recupera as parcelas pendentes de envio ao DS e grava na base do DS
   * @return Operacao realizada com sucesso
   */
  gravarParcelasAcordoDS(): __Observable<Message> {
    return this.gravarParcelasAcordoDSResponse().pipe(
      __map(_r => _r.body as Message)
    );
  }
}

module ParcelaService {

  /**
   * Parameters for obterParcelas
   */
  export interface ObterParcelasParams {

    /**
     * Codigo do acordo
     */
    codigoAcordo: number;

    /**
     * Codigo do parcela
     */
    codigoParcela?: number;
  }

  /**
   * Parameters for obterParcelasLoteFatura
   */
  export interface ObterParcelasLoteFaturaParams {

    /**
     * Codigo do ramo do sinistro
     */
    ramoSinistro?: number;

    /**
     * Data inicial da pesquisa
     */
    periodoInicial?: string;

    /**
     * Data final da pesquisa
     */
    periodoFinal?: string;

    /**
     * Quantidade registros por pagina
     */
    perPage?: number;

    /**
     * Pagina inicial
     */
    page?: number;

    /**
     * Numero do sinistro
     */
    numeroSinistro?: number;

    /**
     * Codigo do escritorio
     */
    codigoEscritorio?: number;

    /**
     * Ano do sinistro
     */
    anoSinistro?: number;
  }

  /**
   * Parameters for obterParcelasLoteHonorario
   */
  export interface ObterParcelasLoteHonorarioParams {

    /**
     * Codigo do ramo do sinistro
     */
    ramoSinistro?: number;

    /**
     * Data inicial da pesquisa
     */
    periodoInicial?: string;

    /**
     * Data final da pesquisa
     */
    periodoFinal?: string;

    /**
     * Quantidade registros por pagina
     */
    perPage?: number;

    /**
     * Pagina inicial
     */
    page?: number;

    /**
     * Codigo identificador do tipo de procedencia
     */
    codigoTipoProcedencia?: number;

    /**
     * Codigo da Modalidade (Marca)
     */
    codigoModalidade?: number;

    /**
     * Codigo do escritorio
     */
    codigoEscritorio?: number;

    /**
     * Ano do sinistro
     */
    anoSinistro?: number;
  }

  /**
   * Parameters for obterParcelasReceberLoteHonorario
   */
  export interface ObterParcelasReceberLoteHonorarioParams {

    /**
     * Codigo do ramo do sinistro
     */
    ramoSinistro?: number;

    /**
     * Data inicial da pesquisa
     */
    periodoInicial?: string;

    /**
     * Data final da pesquisa
     */
    periodoFinal?: string;

    /**
     * Quantidade registros por pagina
     */
    perPage?: number;

    /**
     * Pagina inicial
     */
    page?: number;

    /**
     * Codigo identificador do tipo de procedencia
     */
    codigoTipoProcedencia?: number;

    /**
     * Codigo da Modalidade (Marca)
     */
    codigoModalidade?: number;

    /**
     * Codigo do escritorio
     */
    codigoEscritorio?: number;

    /**
     * Ano do sinistro
     */
    anoSinistro?: number;
  }

  /**
   * Parameters for obterParcelasParaConciliacao
   */
  export interface ObterParcelasParaConciliacaoParams {

    /**
     * Item do sinistro
     */
    sequenciaItemSinistro?: number;

    /**
     * Item do sinistro
     */
     sequenciaItemSinistro1?: any;

    /**
     * Item do sinistro
     */
     sequenciaItemSinistro2?: any;

    /**
     * Item do sinistro
     */
     sequenciaItemSinistro3?: any;

    /**
     * Item do sinistro
     */
     sequenciaItemSinistro4?: any;

    /**
     * Item do sinistro
     */
     sequenciaItemSinistro5?: any;

    /**
     * Item do sinistro
     */
     sequenciaItemSinistro6?: any;

    /**
     * Item do sinistro
     */
     sequenciaItemSinistro7?: any;

    /**
     * Item do sinistro
     */
     sequenciaItemSinistro8?: any;

    /**
     * Item do sinistro
     */
     sequenciaItemSinistro9?: any;

    /**
     * Codigo do ramo do sinistro
     */
    ramoSinistro?: number;

    /**
     * Codigo do ramo do sinistro
     */
    ramoSinistro1?: any;

    /**
     * Codigo do ramo do sinistro
     */
     ramoSinistro2?: any;
     
     /**
     * Codigo do ramo do sinistro
     */
    ramoSinistro3?: any;

    /**
     * Codigo do ramo do sinistro
     */
     ramoSinistro4?: any;

     /**
     * Codigo do ramo do sinistro
     */
    ramoSinistro5?: any;

    /**
     * Codigo do ramo do sinistro
     */
     ramoSinistro6?: any;

     /**
     * Codigo do ramo do sinistro
     */
    ramoSinistro7?: any;

    /**
     * Codigo do ramo do sinistro
     */
     ramoSinistro8?: any;

     /**
     * Codigo do ramo do sinistro
     */
    ramoSinistro9?: any;

    /**
     * Quantidade registros por pagina
     */
    perPage?: number;

    /**
     * Pagina inicial
     */
    page?: number;

    /**
     * Numero do sinistro
     */
    numeroSinistro?: number;

    /**
     * Numero do sinistro
     */
    numeroSinistro1?: any;

    /**
     * Numero do sinistro
     */
     numeroSinistro2?: any;

    /**
     * Numero do sinistro
     */
     numeroSinistro3?: any;

    /**
     * Numero do sinistro
     */
     numeroSinistro4?: any;

    /**
     * Numero do sinistro
     */
     numeroSinistro5?: any;

    /**
     * Numero do sinistro
     */
     numeroSinistro6?: any;

    /**
     * Numero do sinistro
     */
     numeroSinistro7?: any;

    /**
     * Numero do sinistro
     */
     numeroSinistro8?: any;

    /**
     * Numero do sinistro
     */
     numeroSinistro9?: any;

    /**
     * Cpf/Cnpj
     */
    cpfCnpj?: string;

    /**
     * Codigo identificador do tipo de procedencia
     */
    codigoTipoProcedencia?: number;

    /**
     * Codigo status da parcela
     */
    codigoStatus?: number;

    /**
     * Codigo da Modalidade (Marca)
     */
    codigoModalidade?: number;

    /**
     * Codigo do escritorio
     */
    codigoEscritorio?: number;

    /**
     * Codigo do acordo
     */
    codigoAcordo?: number;

    /**
     * Codigo do acordo
     */
     codigoAcordo1?: any;

    /**
     * Codigo do acordo
     */
     codigoAcordo2?: any;

    /**
     * Codigo do acordo
     */
     codigoAcordo3?: any;

    /**
     * Codigo do acordo
     */
     codigoAcordo4?: any;

    /**
     * Codigo do acordo
     */
     codigoAcordo5?: any;

    /**
     * Codigo do acordo
     */
     codigoAcordo6?: any;

    /**
     * Codigo do acordo
     */
     codigoAcordo7?: any;

    /**
     * Codigo do acordo
     */
     codigoAcordo8?: any;

    /**
     * Codigo do acordo
     */
     codigoAcordo9?: any;

    /**
     * Ano do sinistro
     */
    anoSinistro?: number;

    /**
     * Ano do sinistro
     */
    anoSinistro1?: any;

    /**
     * Ano do sinistro
     */
     anoSinistro2?: any;
     
    /**
     * Ano do sinistro
     */
    anoSinistro3?: any;
    
    /**
     * Ano do sinistro
     */
     anoSinistro4?: any;
     
    /**
     * Ano do sinistro
     */
    anoSinistro5?: any;
    
    /**
     * Ano do sinistro
     */
     anoSinistro6?: any;
     
    /**
     * Ano do sinistro
     */
    anoSinistro7?: any;
    
    /**
     * Ano do sinistro
     */
     anoSinistro8?: any;
     
    /**
     * Ano do sinistro
     */
    anoSinistro9?: any;
  }
}

export { ParcelaService }
